import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import {
    Nav,
    NavItem,
    UncontrolledCollapse,
    ModalHeader,
    ModalBody,
    Modal, Row,
    Collapse, CustomInput
} from 'reactstrap';
import classnames from 'classnames';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import { withRouter, Redirect } from 'react-router-dom';
import { AxiosAPI, getGroupID, getUserID } from '../../../../../../helpers/AxiosAPI';
import {
    gAPI_Users_By_Id,
    gAPI_Internal_Property_By_Id,
    gAPI_Group_By_Id,
} from '../../../../../../constants/APIs';
import IntlMessages from '../../../../../../helpers/IntlMessages';

import {
    setContainerClassnames,
    addContainerClassname,
    changeDefaultClassnames,
    changeSelectedMenuHasSubItems,
    changeDomains,
    ChangeGroupId,
    CheckVoucherEngine,
} from '../../../../../../redux/actions';

import menuItems from '../../../../../../constants/menu';
import dialogLogins from '../../../../../../data/dialogLogins';

class Submenu extends Component {
    constructor(props) {
        super(props);

        this.state = {
            role: 'Admin',
            selectedParentMenu: '',
            viewingParentMenu: '',
            domains: [],
            isAvailable: false,
            isSubmenuOpen: false,
            isVirtualFrontDesk: false,
            isRateBooking: false,
            isGuestService: false,
            trainingCollpase: true,
            roomCollpase: true,
            flowCollpase: true,
            copilotCollpase: true,
            selectedCategory: {}, // Stores active categories (already exists)
            checkedCategories: {},
        };
    }

    handleWindowResize = (event) => {
        if (event && !event.isTrusted) {
            return;
        }
        const { containerClassnames } = this.props;
        let nextClasses = this.getMenuClassesForResize(containerClassnames);
        this.props.setContainerClassnames(
            0,
            nextClasses.join(' '),
            this.props.selectedMenuHasSubItems
        );
    };

    handleDocumentClick = (e) => {
        const container = this.getContainer();
        let isMenuClick = false;
        if (
            e.target &&
            e.target.classList &&
            (e.target.classList.contains('menu-button') ||
                e.target.classList.contains('menu-button-mobile'))
        ) {
            isMenuClick = true;
        } else if (
            e.target.parentElement &&
            e.target.parentElement.classList &&
            (e.target.parentElement.classList.contains('menu-button') ||
                e.target.parentElement.classList.contains('menu-button-mobile'))
        ) {
            isMenuClick = true;
        } else if (
            e.target.parentElement &&
            e.target.parentElement.parentElement &&
            e.target.parentElement.parentElement.classList &&
            (e.target.parentElement.parentElement.classList.contains('menu-button') ||
                e.target.parentElement.parentElement.classList.contains(
                    'menu-button-mobile'
                ))
        ) {
            isMenuClick = true;
        }
        if (container.contains(e.target) || container === e.target || isMenuClick) {
            return;
        }
        this.setState({
            viewingParentMenu: '',
        });
        this.toggle();
    };

    getMenuClassesForResize = (classes) => {
        const { menuHiddenBreakpoint, subHiddenBreakpoint } = this.props;
        let nextClasses = classes.split(' ').filter((x) => x !== '');
        const windowWidth = window.innerWidth;
        if (windowWidth < menuHiddenBreakpoint) {
            nextClasses.push('menu-mobile');
        } else if (windowWidth < subHiddenBreakpoint) {
            nextClasses = nextClasses.filter((x) => x !== 'menu-mobile');
            if (
                nextClasses.includes('menu-default') &&
                !nextClasses.includes('menu-sub-hidden')
            ) {
                nextClasses.push('menu-sub-hidden');
            }
        } else {
            nextClasses = nextClasses.filter((x) => x !== 'menu-mobile');
            if (
                nextClasses.includes('menu-default') &&
                nextClasses.includes('menu-sub-hidden')
            ) {
                nextClasses = nextClasses.filter((x) => x !== 'menu-sub-hidden');
            }
        }
        return nextClasses;
    };

    getContainer = () => {
        return ReactDOM.findDOMNode(this);
    };

    toggle = () => {
        const hasSubItems = this.getIsHasSubItem();
        this.props.changeSelectedMenuHasSubItems(hasSubItems);
        const { containerClassnames, menuClickCount } = this.props;
        const currentClasses = containerClassnames
            ? containerClassnames.split(' ').filter((x) => x !== '')
            : '';
        let clickIndex = -1;

        if (!hasSubItems) {
            if (
                currentClasses.includes('menu-default') &&
                (menuClickCount % 4 === 0 || menuClickCount % 4 === 3)
            ) {
                clickIndex = 1;
            } else if (
                currentClasses.includes('menu-sub-hidden') &&
                (menuClickCount === 2 || menuClickCount === 3)
            ) {
                clickIndex = 0;
            } else if (
                currentClasses.includes('menu-hidden') ||
                currentClasses.includes('menu-mobile')
            ) {
                clickIndex = 0;
            }
        } else {
            if (currentClasses.includes('menu-sub-hidden') && menuClickCount === 3) {
                clickIndex = 2;
            } else if (
                currentClasses.includes('menu-hidden') ||
                currentClasses.includes('menu-mobile')
            ) {
                clickIndex = 0;
            }
        }
        if (clickIndex >= 0) {
            this.props.setContainerClassnames(
                clickIndex,
                containerClassnames,
                hasSubItems
            );
        }
    };

    handleProps = () => {
        this.addEvents();
    };

    addEvents = () => {
        ['click', 'touchstart', 'touchend'].forEach((event) =>
            document.addEventListener(event, this.handleDocumentClick, true)
        );
    };

    removeEvents = () => {
        ['click', 'touchstart', 'touchend'].forEach((event) =>
            document.removeEventListener(event, this.handleDocumentClick, true)
        );
    };

    setSelectedLiActive = (callback) => {
        const oldli = document.querySelector('.sub-menu  li.active');
        if (oldli != null) {
            oldli.classList.remove('active');
        }

        /* set selected parent menu */
        const selectedlink = document.querySelector('.sub-menu  a.active');
        if (selectedlink != null) {
            selectedlink.parentElement.classList.add('active');
            this.setState(
                {
                    selectedParentMenu:
                        selectedlink.parentElement.parentElement.getAttribute(
                            'data-parent'
                        ),
                },
                callback
            );
        } else {
            var selectedParentNoSubItem = document.querySelector(
                '.main-menu  li a.active'
            );
            if (selectedParentNoSubItem != null) {
                this.setState(
                    {
                        selectedParentMenu:
                            selectedParentNoSubItem.getAttribute('data-flag'),
                    },
                    callback
                );
            } else if (this.state.selectedParentMenu === '') {
                if (menuItems[0].to === window.location.pathname) {
                    this.setState(
                        {
                            selectedParentMenu: menuItems[0].id,
                        },
                        callback
                    );
                }
            }
        }
    };

    setHasSubItemStatus = () => {
        const hasSubmenu = this.getIsHasSubItem();
        this.props.changeSelectedMenuHasSubItems(hasSubmenu);
        this.toggle();
    };

    getIsHasSubItem = () => {
        const { selectedParentMenu } = this.state;
        const menuItem = menuItems.find((x) => x.id === selectedParentMenu);
        if (menuItem)
            return menuItem && menuItem.subs && menuItem.subs.length > 0
                ? true
                : false;
        else return false;
    };

    checkMenuAccess = (menudomains, type) => {

        if (type !== undefined) {
            const userId = getUserID();

            const login = dialogLogins.filter(
                (m) =>
                    m.label === type && m.logins.filter((l) => l === userId).length > 0
            );

            if (login.length > 0) {

                return true;
            } else {

                return false;
            }
        }
        if (menudomains !== undefined) {

            let hasAccess = false;

            this.state.domains.forEach((p) => {
                menudomains.forEach((r) => {
                    if (this.state.isAvailable) {

                        if (p.type === r) {
                            hasAccess = true;
                        }
                    } else {
                        if (p.type === r) {
                            hasAccess = true;
                        }
                    }
                });
            });

            return hasAccess;
        } else return true;
    };

    checkSpaceBookingVisible = (type) => {
        if (type === 'spaceBookings') {
            if (this.state.isSpaceBooking) {
                return true;
            } else {
                return false;
            }
        } else {
            return true;
        }
    };

    checkVirtualMenuVisible = (type) => {
        if (type === 'virtualfrontdesk') {
            if (this.state.isVirtualFrontDesk) {
                return true;
            } else {
                return false;
            }
        } else if (type === 'ratesbookings') {
            if (this.state.isRateBooking) {
                return true;
            } else {
                return false;
            }
        } else {
            return true;
        }
    };
    checkSubMenuVisible(menudomains, type) {
        let hasAccess = false;
        if (menudomains !== undefined) {
            menudomains.forEach((r) => {
                if (r === 'AccommodationProviders') {
                    hasAccess = true;
                }
            });
        }
        if (hasAccess && type === 'menu.guestservice') {
            if (this.state.isGuestService) {
                return true;
            } else {
                return false;
            }
        } else {
            return true;
        }
    }

    handleCategoryChange = (to, e) => {
        e.preventDefault();

        this.props.history.push(to);
        this.setState((prevState) => {
            const updatedSelectedCategory = { ...prevState.selectedCategory };
            if (updatedSelectedCategory[to]) {
                delete updatedSelectedCategory[to];
            } else {
                updatedSelectedCategory[to] = true;
            }
            return { selectedCategory: updatedSelectedCategory };
        });
    };


    componentDidUpdate(prevProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            this.setSelectedLiActive(this.setHasSubItemStatus);

            let nextClasses = ['menu-sub-hidden'];
            this.props.setContainerClassnames(
                0,
                nextClasses.join(' '),
                this.props.selectedMenuHasSubItems
            );
            window.scrollTo(0, 0);
        }
        this.handleProps();
    }

    componentDidMount() {
        AxiosAPI({
            method: 'get',
            url: `${gAPI_Users_By_Id}/${getUserID()}?gid=${getGroupID()}`,
        })
            .then((res) => {

                res.data?.roles && res.data.roles.forEach((r) => {
                    if (r === 'User' && res.data.roles.length === 1) {
                        this.setState({ role: 'User' });
                    } else if (r === 'Agent' && res.data.roles.length === 1) {
                        this.setState({ role: 'Agent' });
                    }
                })
            });
        if (this.props.propertyId === '-1') {
            AxiosAPI({
                method: 'get',
                url: `${gAPI_Group_By_Id}/${getGroupID()}`,
            }).then((g) => {
                const allgroups = [{ type: 'AllGroups', priority: 1 }];
                if (g.data.domain !== '') {
                    allgroups.push({ type: g.data.domain, priority: 1 });
                }
                this.setState({ domains: allgroups, isVirtualFrontDesk: true });
                this.props.CheckVoucherEngine(false);
                this.props.changeDomains(allgroups);
            });
        } else {
            AxiosAPI({
                method: 'get',
                url: `${gAPI_Internal_Property_By_Id}/${this.props.propertyId
                    }?group_id=${getGroupID()}`,
            })
                .then((res) => {
                    let val = 0;
                    res.data.domains.map((d) => {
                        if (d.type === 'VoucherEngine') {
                            val = 1;
                        }
                    });
                    if (val === 1) {
                        this.setState({ isAvailable: true });
                        this.props.CheckVoucherEngine(true);
                        this.props.ChangeGroupId(getGroupID());
                    } else {
                        this.props.CheckVoucherEngine(false);
                        this.props.ChangeGroupId(getGroupID());
                    }
                    this.setState({
                        domains: res.data.domains,
                        isVirtualFrontDesk: res.data.isVirtualFrontDesk,
                        isRateBooking: res.data.isRateBooking,
                        isGuestService: res.data.isGuestService,
                        isSpaceBooking: res.data.isSpaceBooking,
                    });
                    this.props.changeDomains(res.data.industryDomains);
                })
                .catch((err) => console.error(err));
        }
        window.addEventListener('resize', this.handleWindowResize);
        this.handleWindowResize();
        this.handleProps();
        this.setSelectedLiActive(this.setHasSubItemStatus);
        const selectedParent = menuItems.filter(
            (f) => f.to === window.location.pathname
        );
        if (selectedParent !== undefined && selectedParent.length === 0) {
            this.props.changeSelectedMenuHasSubItems(false);
            this.setState({
                viewingParentMenu: '',
                selectedParentMenu: '',
            });
            this.toggle();
        }
        else if (selectedParent !== undefined && selectedParent.length > 0 ||
            (selectedParent[0].subs === undefined && selectedParent[0].subs.length === 0)) {
            this.props.changeSelectedMenuHasSubItems(false);
            this.setState({
                viewingParentMenu: '',
                selectedParentMenu: '',
            });
            this.toggle();
        }
    }

    componentWillUnmount() {
        this.removeEvents();
        window.removeEventListener('resize', this.handleWindowResize);
    }

    shouldExcludeCategory = (sub) => {
        const excludeCategories = [
            'property-info.faq',
            'property-info.documents',
            'menu.product_services',
            'property-info.publish-ai',
            'property-info.pre-built-templates',
            'property-info.room-types'
        ];
        return excludeCategories.includes(sub.label);
    };

    render() {
        const {
            selectedParentMenu,
            viewingParentMenu,
            domains, role,
        } = this.state;


        const { selectedCategory, allCount } = this.props;
        const submenu = (item, val) => {
            return item.subs
                .filter((f) => f.filter === val)
                .map((sub, index) => {
                    if (this.shouldExcludeCategory(sub)) {
                        return null;
                    }
                    if (
                        this.checkMenuAccess(sub.domains, sub.type) &&
                        this.checkSubMenuVisible(sub.domains, sub.label)
                    ) {
                        const isCheckedFromUrl = window.location.href.includes(sub.to);

                        const isChecked = this.state.checkedCategories[sub.to] || isCheckedFromUrl;

                        return (
                            <NavItem
                                key={`${item.id}_${index}`}
                            // className={isActive ? 'active' : ''}

                            >
                                <Fragment>
                                    <Row className="ml-1">
                                        <Colxx xxs="1" className="text-left">
                                            <CustomInput
                                                type="checkbox"
                                                id={`checkbox_${item.id}_${index}`}
                                                checked={isChecked || false}
                                                onClick={(e) => this.handleCategoryChange(sub.to, e)}
                                            />
                                        </Colxx>
                                        <Colxx xxs="8">
                                            <IntlMessages id={sub.label} />
                                        </Colxx>
                                        <Colxx xxs="1" className="">
                                            <span>
                                                {sub?.count && sub.count !== null ? sub.count : '0'}

                                            </span>
                                        </Colxx>
                                    </Row>
                                </Fragment>
                            </NavItem>
                        );
                    }
                });
        };



        return (
            <Fragment>
                <div className="">
                    <Nav>
                        {menuItems &&
                            menuItems.map((item) => {
                                if (
                                    (role === 'Admin' ||
                                        (role === 'User' &&
                                            item.label !== 'menu.admin' &&
                                            item.label !== 'menu.userroles') ||
                                        (role === 'Agent' &&
                                            item.label !== 'menu.admin' &&
                                            item.label !== 'menu.userroles')) &&
                                    this.checkMenuAccess(item.domains, item.type) ===
                                    true &&
                                    this.checkVirtualMenuVisible(item.id) === true &&
                                    this.checkSpaceBookingVisible(item.id) === true
                                )
                                    return (
                                        <NavItem key={item.id}>
                                            {item?.label === 'menu.propinfo' && (
                                                <Fragment>
                                                    <Nav key={item.id} data-parent={item.id}>
                                                        {item.subs && item.subs.length > 0 && (
                                                            <Fragment>
                                                                {item.subs
                                                                    .filter((f) => f.filter === 'training')
                                                                    .filter(
                                                                        (sub, index) =>
                                                                            this.checkMenuAccess(
                                                                                sub.domains,
                                                                                sub.type
                                                                            ) === true &&
                                                                            this.checkSubMenuVisible(
                                                                                sub.domains,
                                                                                sub.label
                                                                            ) === true
                                                                    ).length > 0 && (
                                                                        <div>
                                                                            {submenu(item, 'training')}
                                                                        </div>
                                                                    )}
                                                            </Fragment>
                                                        )}
                                                    </Nav>
                                                </Fragment>
                                            )}
                                        </NavItem>
                                    );
                            })}
                    </Nav>
                </div>
            </Fragment>
        );

    }
}
const mapStateToProps = ({ menu, settings }) => {
    const {
        containerClassnames,
        subHiddenBreakpoint,
        menuHiddenBreakpoint,
        menuClickCount,
        selectedMenuHasSubItems,
    } = menu;
    const { locale, propertyId } = settings;
    return {
        containerClassnames,
        subHiddenBreakpoint,
        menuHiddenBreakpoint,
        menuClickCount,
        selectedMenuHasSubItems,
        locale,
        propertyId,
    };
};


export default withRouter(
    connect(mapStateToProps, {
        setContainerClassnames,
        addContainerClassname,
        changeDefaultClassnames,
        changeSelectedMenuHasSubItems,
        changeDomains,
        CheckVoucherEngine,
        ChangeGroupId,
    })(Submenu)
);
